import { accountSlice } from './accountSlice'

export const accountReducer = accountSlice.reducer
export const {
  setSignatureUploadProgress,
  successSignatureUploadFile,
  failureSignatureUploadFile,
  setSignatureCancelToken,
} = accountSlice.actions
